import React from 'react';

const ArtistList = ({ artists, removeArtist }) => {
  return (
    <div className="selected-artists">
      {artists.map((artist, i) => (
        <div className='selected-artist' key={i}>
          <div className="selected-artist-left">
            <h6>{artist.name}</h6>
            <span>{artist.role}</span>
          </div>
          <i 
            className="fi fi-sr-cross" 
            onClick={() => removeArtist(i)}
          ></i>
        </div>
      ))}
    </div>
  );
};

export default ArtistList; 